import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '../queryKeys';
import {
  getNotifications,
  getUnreadCount,
  markNotificationsRead,
  markAllNotificationsRead,
} from '../api/notifications';

export function useUnreadCount() {
  const { data = 0 } = useQuery({
    queryKey: queryKeys.lms.notifications.unreadCount(),
    queryFn: async () => {
      const { data } = await getUnreadCount();
      return data.count;
    },
    refetchInterval: 30_000,
  });
  return data;
}

export function useNotifications(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.lms.notifications.list(),
    queryFn: async () => {
      const { data } = await getNotifications(20);
      return data;
    },
    enabled,
    refetchInterval: enabled ? 30_000 : false,
  });
}

export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ids: string[]) => markNotificationsRead(ids),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.lms.notifications.unreadCount() });
      qc.invalidateQueries({ queryKey: queryKeys.lms.notifications.list() });
    },
  });
}

// useMarkAllRead clears every unread notification server-side, so the bell stops
// ringing even when the unread count exceeds the fetched page.
export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => markAllNotificationsRead(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.lms.notifications.unreadCount() });
      qc.invalidateQueries({ queryKey: queryKeys.lms.notifications.list() });
    },
  });
}
